import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import numeral from "numeral";

const options = {
  legend: {
    display: false,
  },
  elements: {
    point: {
      radius: 0,
    },
  },
  maintainAspectRatio: false,
  tooltips: {
    //https://www.chartjs.org/samples/latest/tooltips/interactions.html
    mode: "index",
    intersect: false,
    callbacks: {
      // https://www.chartjs.org/docs/latest/configuration/tooltip.html#label-callback
      label: function (tooltipItem, data) {
        return numeral(tooltipItem.value).format("+0,0");
      },
    },
  },
  //https://www.chartjs.org/docs/latest/axes/cartesian/time.html#time-cartesian-axis
  scales: {
    xAxes: [
      {
        type: "time",
        time: {
          format: "MM/DD/YY",
          tooltipFormat: "ll", //ll is the week format
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function (value, index, values) {
            return numeral(value).format("0a");
          },
        },
      },
    ],
  },
};
const buildChartData = (data, casesType = "cases") => {
  let chartData = [];
  let lastDataPoint;
  for (let date in data.cases) {
    if (lastDataPoint) {
      let newDataPoint = {
        x: date,
        y: data[casesType][date] - lastDataPoint,
        //   the reason we put - lastDataPoint is to get the diff between last date and current date
      };
      chartData.push(newDataPoint);
    }
    lastDataPoint = data[casesType][date];
  }
  return chartData;
};

function LineGraph({ casesType = "cases", ...props }) {
  const [data, setData] = useState({});
  // we want to get historical data for the last 3 months
  //"https://disease.sh/v3/covid-19/historical/all?lastdays=120"

  useEffect(() => {
    const fetchData = async () => {
      await fetch("https://disease.sh/v3/covid-19/historical/all?lastdays=120")
        .then((response) => response.json())
        .then((data) => {
          // do things here
          let chartData = buildChartData(data, casesType);
          console.log(chartData);

          setData(chartData);
        });
    };

    fetchData();
  }, [casesType]);

  return (
    <div className="props.className">
      {/* we need to check if the data exists, if it doesn't, it will not crash */}
      {data?.length > 0 && (
        <Line
          options={options}
          data={{
            datasets: [
              {
                responsive: true,
                backgroundColor: "#A0D2EB",
                borderColor: "#494D5F",
                data: data,
                hoverBackgroundColor: "#CC1034",
              },
            ],
          }}
        />
      )}
    </div>
  );
}
export default LineGraph;
